import { Outlet } from 'react-router-dom';
import Navbar from './feature/Navbar';
import Footer from './feature/Footer';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
